<div class="welcome">
    <img class="mb-4" src="/assets/logo_dark.png" alt="" height="57">

    <h1>Welcome to weavix™&nbsp;Control&nbsp;Center</h1>

    <p>Click on a link on the left to get started.</p>
</div>
